import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ePayService } from './Service/ePayService';
import { FormComponent } from './Form/form.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [FormComponent]
})
export class AppComponent {

  constructor(
    private readonly location: LocationStrategy,
    private readonly ePayService: ePayService,
    private readonly http: HttpClient
  ) {
    // Navigate forward in history if possible
    this.location.forward();
  }

  ngOnInit(): void {
    console.info('bearer');
    this.bearer().subscribe({
      next: (data) => {
        console.info('this.sessionid', data);
        console.info('this.ePayService.sessionId', this.ePayService?.sessionId);
        this.ePayService.sessionId = data?.sessionId ?? '';
      },
      error: (err) => {
        console.error('Bearer request failed', err);
      }
    });
  }

  get sessionId() {
    return this.ePayService.sessionId;
  }

  bearer(): Observable<{ sessionId: string }> {
    const formData = new FormData();
    const headers = new HttpHeaders();

    const path = window.location.pathname;
    if (path) {
      const hash = path.substring(path.lastIndexOf('/') + 1);
      formData.append('hash', hash);
    }

    return this.http.post<{ sessionId: string }>('/ePay/Bearer', formData, { headers });
  }

  onActivate = (event: unknown): void => {
    // Placeholder for route activation logic
  };
}

/*
import { Component, Attribute, Input } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ePayService } from './Service/ePayService';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(
    private location: LocationStrategy,
    private ePayService: ePayService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {
    // check if back or forward button is pressed.
    this.location.forward();
  }

  ngOnInit() {
    console.info('bearer');
    this.bearer().subscribe((data: any) => {
      console.info('this.sessionid', data);
      console.info('this.ePayService.sessionId', this.ePayService?.sessionId);
      this.ePayService.sessionId = data.sessionId;
    });
  }

  get sessionId() {
    return this.ePayService.sessionId;
  }

  bearer() {
    let _formdata = new FormData();
    let headers = new HttpHeaders();
    if (window.location.pathname) {
      var hash = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1);
      _formdata.append("hash", hash);
    }
    return this.http.post<any>('/ePay/Bearer', _formdata, { headers });
  }

  onActivate = (event: any) => {
  }
}
*/
/*

import {  Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InvisibleReCaptchaComponent, } from 'ngx-captcha';
import { AuthService } from './service/Auth.service';
import { InactivityLogoutService } from './service/InactivityLogoutService.service';
import { Observable, debounceTime, fromEvent, merge, tap } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [],
    standalone: false
})
export class AppComponent {
  @ViewChild('captchaElem', { static: false }) captchaElem: InvisibleReCaptchaComponent | undefined;
  @ViewChild('langInput', { static: false }) langInput: ElementRef | undefined;

  title = 'Dashboard';

  loginStatus$: Observable<boolean>; // Observable for login status
  private userActivitySubscription: any; // Subscription for user activity events

  constructor(
    private authService: AuthService,
    private inactivityLogoutService: InactivityLogoutService,
    private router: Router
  ) {
    // Initialize the login status observable
    this.loginStatus$ = this.authService.loginStatus$.pipe(
      tap(loggedIn => {
        console.log('loginStatus$', loggedIn);
        if (loggedIn) {
          this.router.navigate(['dashboard']);
          this.inactivityLogoutService.resetTimer();
        }
      })
    );
  }

  ngOnInit() {
    this.loginStatus$.subscribe();
    // Initialize user activity event listeners
    this.setupUserActivityListeners();
  }

  ngOnDestroy() {
    // Unsubscribe from user activity events
    if (this.userActivitySubscription) {
      this.userActivitySubscription.unsubscribe();
    }
  }

  //Check for inactivity while the user is on the page.
  private setupUserActivityListeners = () => {
    // Combine mousemove and keydown events with debounce
    const mousemove$ = fromEvent(document, 'mousemove');
    const keydown$ = fromEvent(document, 'keydown');

    // Merge both events into a single observable and debounce
    this.userActivitySubscription = merge(mousemove$, keydown$).pipe(
      debounceTime(300), // Debounce to prevent excessive reset calls
      tap(() => this.inactivityLogoutService.resetTimer())
    ).subscribe();
  }
}
*/
